import { ApiService } from '../../service/api/ApiService'

/**
 * @type {string} Endpoint получения всех компаний
 */
const allCompanyEndpoint = 'companies'
const companyEndpoint = 'company/{id}'

/**
 * Метод получающий компании.
 *
 * @param context Стейт
 * @returns {Promise<null|*>}
 */
const findAllCompanies = async (context) => {
  context.commit('fetchCompanies')
  try {
    const response = await ApiService.get(allCompanyEndpoint)
    context.commit('fetchCompaniesSuccess', response.data.data)
    return response.data.data
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchCompaniesError', error)
    return null
  }
}

const findById = async (context, id) => {
  context.commit('fetchCompany')
  try {
    const { data } = await ApiService.get(companyEndpoint.replace('{id}', id))
    const response = data === undefined ? null : data
    context.commit('fetchCompanySuccess', response)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchCompanyError', error)
    return null
  }
}

const updateCompany = async (context, formData) => {
  context.commit('snackBarModules/clearModalState', false, { root: true })
  try {
    const { data } = await ApiService.put(companyEndpoint.replace('{id}', formData.id), formData)
    const response = data === undefined ? null : data
    context.commit('updateCompanySuccess', response)
    context.commit('snackBarModules/showSuccessModal', 'Успешно обновлено', { root: true })
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('updateCompanyError', error)
    return null
  }
}

const addCompany = async (context, formData) => {
  context.commit('addCompany')
  context.commit('snackBarModules/clearModalState', false, { root: true })
  try {
    const { data } = await ApiService.post('company', formData)
    const response = data === undefined ? null : data
    context.commit('addCompanySuccess', response)
    context.commit('snackBarModules/showSuccessModal', 'Успешно добавлено', { root: true })
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('addCompanyError', error)
    context.commit('snackBarModules/showErrorModal', error, { root: true })
    return null
  } finally {
    context.dispatch('findAllCompanies')
  }
}

export default {
  findAllCompanies, findById, updateCompany, addCompany
}
